import {isFunction, map} from 'lodash';
import {
    Bar,
    BarChartProps,
    BarProps,
    CartesianGrid,
    Cell,
    CellProps,
    BarChart as RechartsBarChart, ResponsiveContainer, Tooltip, XAxis, XAxisProps, YAxis, YAxisProps
} from 'recharts';

type CustomCellProps = CellProps & {fillFn?: (item: any) => string};
type CustomBarProps = BarProps & {cell?: CustomCellProps};

type Props = {
    xAxis?: XAxisProps;
    yAxis?: YAxisProps;
    width?: number | string;
    height?: number | string;
    gridStep?: number;
    bars: CustomBarProps[];
    tooltip?: React.ReactElement
} & BarChartProps;

export const BarChart: React.FC<Props> = ({xAxis, yAxis, bars = [], tooltip, width = '100%', height = 300, gridStep = 2, ...barProps}) => (
    <ResponsiveContainer height={height} width={width}>
        <RechartsBarChart {...barProps}>
            {gridStep && <CartesianGrid strokeDasharray={`${gridStep} ${gridStep}`} />}
            {xAxis && <XAxis {...xAxis} />}
            {yAxis && <YAxis {...yAxis} allowDecimals={false} />}
            {tooltip && <Tooltip content={tooltip} />}
            {map(bars, (bar) => (
                <Bar {...bar} key={bar.dataKey.toString()}>
                    {bar.cell && map(barProps.data, (entry, index) => (
                        <Cell
                            key={`cell-${index}`}
                            {...bar.cell}
                            fill={isFunction(bar.cell.fillFn) ? bar.cell.fillFn(entry) : bar.cell.fill}
                        />
                    ))}
                </Bar>
            ))}
        </RechartsBarChart>
    </ResponsiveContainer>
);